module.exports = __webpack_public_path__ + "img/avatar-svgrepo-com.679eaf52.svg";